// Em src/components/RedirectToExternal.js
import { useEffect } from "react";

// Defina uma interface para as props do componente
interface RedirectToExternalProps {
  url: string; // Defina o tipo da propriedade url como string
}

const RedirectToExternal: React.FC<RedirectToExternalProps> = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  // Renderiza algo enquanto o redirecionamento não é concluído (opcional)
  return <div>Essa página não existe redirecionando para <b>cupcode.com.br</b></div>;
};

export default RedirectToExternal;
